export function undefOrNull (v) {
    return (v === undefined) || (v === null);
}

export function undefOrNullOrEmptyStr (v) {
    return (v === undefined) || (v === null) || (v === "");
}
